import { useMemo } from 'react';
import { EnvConfig, ScsUrlParts, useServicesContext } from '@oneaudi/vtp-shared';
import { getAppContentConfiguration, oneCMSVtpConfiguration } from './tileHook';

/**
 * this hook generates correct scs request urls using the market, language, version and scsBaseUrl
 * provided by the current '[[ServicesContext]]' in which this apps lives
 */
export const useScsUrlParts = (): ScsUrlParts => {
  const { getEnvironmentConfig } = useServicesContext();
  const content = getAppContentConfiguration();
  const {
    versionsMapping,
    marketPath,
    language,
    market,
    scsBaseUrl,
    defaultVersion,
    isUsedCarMkt,
    apiKey,
  } = getScsUrlPartsFromConfiguration(content.vtpConfiguration?.fields, getEnvironmentConfig());

  return useMemo(
    () => ({
      versionsMapping,
      marketPath,
      language,
      market,
      scsBaseUrl,
      defaultVersion,
      isUsedCarMkt,
      apiKey,
    }),
    [
      defaultVersion,
      language,
      market,
      marketPath,
      scsBaseUrl,
      versionsMapping,
      isUsedCarMkt,
      apiKey,
    ]
  );
};

export const getScsUrlPartsFromConfiguration = (
  configuration?: oneCMSVtpConfiguration,
  envConfig?: EnvConfig | null
): ScsUrlParts => {
  const versionsMapping = envConfig?.scs.apiVersionMapping ?? {
    version: '',
    filter: '',
    match: '',
  };

  const defaultVersion = envConfig?.scs.defaultApiVersion ?? '';
  const marketPath = configuration?.scs_scsMarketPath ?? '';
  const [language, market] = marketPath ? marketPath.split('/') : [];
  const scsBaseUrl = envConfig?.scs.baseUrl ?? '';
  const apiKey = envConfig?.scs.apiKey ?? '';
  const isUsedCarMkt = marketPath ? marketPath.includes('uc') : false;

  return {
    versionsMapping,
    marketPath,
    language,
    market,
    scsBaseUrl,
    defaultVersion,
    isUsedCarMkt,
    apiKey,
  };
};
